"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAgentInformation = void 0;
/**
 * Fetch the agent information by passing his/her id.
 *
 * @public
 *
 * @typeParam T The type of the repository that should be derived from {@link IAgentRepository}
 *
 * @param repository The repository instance to handle agents. See {@link agentRepository}
 *
 * @returns An async object with the agent information. If there is no information or there is a network error, null is returned.
 *
 * @example
 * ```ts
 * const agent = await fetchAgentInformation(agentRepository);
 * ```
 */
async function fetchAgentInformation(repository, agentId) {
    try {
        return await repository.fetchAgentInformation(agentId);
    }
    catch (error) {
        // TODO: add raygun notification
        return null;
    }
}
exports.fetchAgentInformation = fetchAgentInformation;
//# sourceMappingURL=fetch-agent-information.js.map